import { addMonths, parseISO } from 'date-fns';
import { RRule }   from 'rrule';

export const RecurrenceRuleGenerator = props => {
	const { days, end, exclusions, count, month, pattern, start } = props;

	const getRRuleDay       = day  => {
		switch (day) {
			case 'Monday':
				return RRule.MO;
			case 'Tuesday':
				return RRule.TU;
			case 'Wednesday':
				return RRule.WE;
			case 'Thursday':
				return RRule.TH;
			case 'Friday':
				return RRule.FR;
			case 'Saturday':
				return RRule.SA;
			case 'Sunday':
				return RRule.SU;
			default:
				break;
		}

		return undefined;
	};

	const getRRuleFrequency = ()   => {
		switch (pattern) {
			case 'Daily':
				return RRule.DAILY;
			case 'Weekly':
				return RRule.WEEKLY;
			case 'Monthly':
				return RRule.MONTHLY;
			default:
				return undefined;
		}
	};

	const getRRuleMonth     = opts =>  {
		switch (month) {
			case 'Recurs Monthly on Week 1':
				opts.bysetpos = 1;
				break;
			case 'Recurs Monthly on Week 2':
				opts.bysetpos = 2;
				break;
			case 'Recurs Monthly on Week 3':
				opts.bysetpos = 3;
				break;
			case 'Recurs Monthly on Week 4':
				opts.bysetpos = 4;
				break;
			case 'Recurs Monthly on Day of Week': {
				const array = [];
				days.forEach(day => array.push(getRRuleDay(day)));
				opts.byweekday = array;
				break;
			}
			case 'Recurs Monthly on Day of Month': {
				const array = [];
				days.forEach(day => array.push(getRRuleDay(day)));
				opts.bymonthday = array;
				break;
			}
			default:
				break;
		}
	};

    const generate = () => {
	    const options  = {
		    count: count || 25,
		    dtstart: typeof start === 'string' ? parseISO(start) : new Date(start),
			freq: getRRuleFrequency(pattern),
			interval: 1,
		    until: end && end.equals('0001-01-01T00:00:00') ? undefined : (typeof end === 'string' ? parseISO(end) : new Date(end)),
			tzid: 'America/Chicago',
			wkst: RRule.SU
	    };

	    if (month) {
			getRRuleMonth(options);
		}
		
	    /*if (days) {
		    const array = [];
		    days.forEach(day => array.push(getRRuleDay(day)));
		    options.byweekday = array;
	    }*/

	    const rrule = new RRule(options);

		if (exclusions && exclusions.length > 0) {
			rrule.exdates = exclusions.map(exclusion => typeof exclusion === 'string' ? parseISO(exclusion) : new Date(exclusion));
		}

		return rrule.between(new Date(), addMonths(new Date(), 6));
		/*return rrule.all();*/
    };

	return generate();
};

export const generateRecurrences  = (event, count) =>
{
    if (!event)
    {
        return undefined;
    }

    const start            = event.startDateAndTime;
    const end              = event.maxRecurringDate;
    const pattern          = event.recurrencePattern;
    const days             = event.recurrenceFrequencyDays;
    const month            = event.recurrenceMonthOptions;
    const doesNotOccur1    = event.eventDoesNotOccurDate;
    const doesNotOccur2    = event.eventDoesNotOccurDate2;
    const doesNotOccur3    = event.eventDoesNotOccurDate3;
    const exclusions       = [];

    if (!pattern)
    {
        return undefined;
    }

    if (doesNotOccur1 && !doesNotOccur1.equals('0001-01-01T00:00:00'))
    {
        exclusions.push(doesNotOccur1);


        if (doesNotOccur2 && !doesNotOccur2.equals('0001-01-01T00:00:00'))
        {
            exclusions.push(doesNotOccur2);
        }


        if (doesNotOccur3 && !doesNotOccur3.equals('0001-01-01T00:00:00'))
        {
            exclusions.push(doesNotOccur3);
        }
    }
    
    return RecurrenceRuleGenerator({
         start, 
         end, 
         pattern, 
         days,
         month, 
         exclusions,
         count
    });
};

export const convertRecurs        = val =>  {
	switch (val)
	{
		case 1:
			return 'Daily';
		case 2:
			return 'Weekly';
		case 3:
			return 'Monthly';
		case 4:
			return 'Yearly';
		case 5:
			return 'BiWeekly';
		default:
			return undefined;
	};
};

export const convertWeekdays      = val => {
	switch (val)
	{
		case 1:
			return 'Monday';
		case 2:
			return 'Tuesday';
		case 4:
			return 'Wednesday';
		case 8:
			return 'Thursday';
		case 16:
			return 'Friday';
		case 32: 
            return 'Saturday';
		case 64: 
			return 'Sunday';
		default:
			return undefined;
	};
};
